import {v4 as uuidv4} from 'uuid';
import ProgressBar from "./ProgressBar";
import KpiGrid from "./KpiGrid";
import "./StyleKpiElement.css"

function KpiElement({name, details}) {

    function purposeId (){
        return uuidv4()
    }

    let mainColor = 'red';
    let progressBarValue = 0, progressBarZone = 'red';

    function getKpiContainerClassColor (mainColor__){
        if (mainColor__ === "green") {
            return "kpi--container green";
        } else if (mainColor__ === "yellow") {
            return "kpi--container orange";
        } else {
            return "kpi--container red";
        }
    }

    function getSmilesColor (mainColor__){
        if (mainColor__ === "green") {
            return "green--smile";
        } else if (mainColor__ === "yellow") {
            return "orange--smile";
        } else {
            return "red--smile";
        }
    }

    for (let i = 0; i < details.length; i++) {
        if (details[i].is_main) {
            mainColor = details[i].zone;
            break;
        }
    }

    return (
        <>
            <div className={`kpi--container ${getKpiContainerClassColor(mainColor)}`}>
                <div className="kpi--container--title">
                    <span className="kpi--container--titleNAme">{name}</span>
                    <div className={`Smile ${getSmilesColor(mainColor)}`}></div>
                </div>

                <div className="kpi--grid">
                    {details?.map((details) => {
                        if (details.is_progressbar) {
                            progressBarValue = details.value;
                            progressBarZone = details.zone;
                        } else {
                            return (
                                <KpiGrid
                                    key={purposeId()}
                                    name={details.name}
                                    value={details.value}
                                    is_percents={details.is_percents}
                                    zone={details.zone}
                                />
                            )
                        }
                    })}
                </div>
                <ProgressBar initialValue={progressBarValue} zone={progressBarZone}/>
            </div>
        </>
    );

}

export default KpiElement;